import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PerfShell } from "@/components/perf/PerfShell";
import { OverviewTab } from "@/components/perf/tabs/OverviewTab";
import { TrafficTab } from "@/components/perf/tabs/TrafficTab";
import { SeoTab } from "@/components/perf/tabs/SeoTab";
import { ContentTab } from "@/components/perf/tabs/ContentTab";
import { AiTab } from "@/components/perf/tabs/AiTab";
import { AuthorityTab } from "@/components/perf/tabs/AuthorityTab";
import { NewsletterTab } from "@/components/perf/tabs/NewsletterTab";
import { GraphTab } from "@/components/perf/tabs/GraphTab";
import { SecurityTab } from "@/components/perf/tabs/SecurityTab";
import { TasksTab } from "@/components/perf/tabs/TasksTab";
import type { PerfTab, DateRange } from "@/lib/perf/types";

const searchSchema = z.object({
  tab: z
    .enum([
      "overview",
      "traffic",
      "seo",
      "content",
      "ai",
      "authority",
      "newsletter",
      "graph",
      "security",
      "tasks",
    ])
    .default("overview"),
  range: z.enum(["7d", "30d", "90d", "ytd", "custom"]).default("30d"),
  lang: z.enum(["all", "tr", "en"]).default("all"),
});

export const Route = createFileRoute("/admin/performance")({
  head: () => ({
    meta: [
      { title: "Performance Dashboard — Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  validateSearch: searchSchema,
  component: PerformancePage,
  errorComponent: ({ error }) => (
    <div className="p-6 text-sm text-clay">Hata: {(error as Error).message}</div>
  ),
  notFoundComponent: () => <div className="p-6">Bulunamadı.</div>,
});

function PerformancePage() {
  const { tab, range } = Route.useSearch() as { tab: PerfTab; range: DateRange };
  return (
    <PerfShell>
      {tab === "overview" && <OverviewTab range={range} />}
      {tab === "traffic" && <TrafficTab range={range} />}
      {tab === "seo" && <SeoTab />}
      {tab === "content" && <ContentTab range={range} />}
      {tab === "ai" && <AiTab range={range} />}
      {tab === "authority" && <AuthorityTab />}
      {tab === "newsletter" && <NewsletterTab range={range} />}
      {tab === "graph" && <GraphTab />}
      {tab === "security" && <SecurityTab />}
      {tab === "tasks" && <TasksTab />}
    </PerfShell>
  );
}
